import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { UiService } from '../../../../core/services/core.ui.service';
import { ForumService } from '../../forum.service';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';

@Component({
  selector: 'forum-thread-delete',
  template: require('./delete.thread.modal.component.html')
})
export class ForumThreadDeleteModalComponent extends ModalComponent {
  @Input() thread: any;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  isLoading = false;

  constructor(
    private stateService: StateService,
    private forumService: ForumService,
    private uiService: UiService
  ) 
  {
    super();
  }

  doDeleteThread() {
    this.forumService.deleteThread(this.thread.id)
    .then(
      () => {
        this.uiService.message.showSuccess(`Deleted ${this.thread.threadName} successfully`, 'Delete Thread');
        this.onClose.emit();
        this.stateService.reload();
      },
      (response) => {
        this.uiService.message.showWarning(`Could not delete ${this.thread.threadName}`, 'Delete Thread');
        this.onClose.emit();
      }
    );
  }
  
  doCloseModal() {
    this.onClose.emit();
  }
}
